import { Point } from "@/lib/math";
import Victor from "victor";

export class ToothLongAxisHelper {

    /**
     * Orderna longo eixo para apontar sempre para raiz. coroa -> raiz
     * @param {[Point, Point]} segment
     * @param {'superior' | 'inferior'} posicaoDente 
     * @returns {[Point, Point]}
     */
    static orderLongAxisSegment(segment, posicaoDente) {
        const pointA = segment.at(0)
        const pointB = segment.at(1)

        const vSegment = Victor.fromObject(pointB).subtract(Victor.fromObject(pointA));
        const lineAngle = vSegment.angleDeg() % 360;

        if (((lineAngle > 0 && lineAngle < 180) && posicaoDente == 'superior')
            || ((lineAngle < 0 && lineAngle > -180) && posicaoDente == 'inferior')) {
            return [pointB, pointA];
        }
        return [pointA, pointB]
    }
}